
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function SecureShopping() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-green-600 rounded-full">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Güvenli Alışveriş</h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Nox Sanat olarak müşterilerimizin güvenliğini en üst düzeyde tutuyoruz. 
              Alışveriş deneyiminizin güvenli ve huzurlu olması için aldığımız önlemler.
            </p>
          </div>
        </div>
      </section>

      {/* Security Features */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
              <div className="bg-gray-900 rounded-lg p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-blue-600 rounded-full">
                  <i className="ri-lock-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4">SSL Şifreleme</h3>
                <p className="text-gray-400">
                  Tüm veri transferleri 256-bit SSL şifreleme ile korunur. 
                  Kişisel bilgileriniz güvenli bir şekilde iletilir.
                </p>
              </div>

              <div className="bg-gray-900 rounded-lg p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-green-600 rounded-full">
                  <i className="ri-bank-card-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4">Güvenli Ödeme</h3>
                <p className="text-gray-400">
                  Kredi kartı bilgileriniz PCI DSS standartlarına uygun 
                  güvenli ödeme sistemleri ile işlenir.
                </p>
              </div>

              <div className="bg-gray-900 rounded-lg p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-purple-600 rounded-full">
                  <i className="ri-user-settings-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4">Gizlilik Koruması</h3>
                <p className="text-gray-400">
                  Kişisel verileriniz KVKK kapsamında korunur ve 
                  üçüncü taraflarla paylaşılmaz.
                </p>
              </div>
            </div>

            {/* Detailed Security Information */}
            <div className="space-y-12">
              <div className="bg-gray-900 rounded-lg p-8">
                <h2 className="text-2xl font-bold mb-6 flex items-center">
                  <i className="ri-shield-check-line text-green-500 mr-3"></i>
                  Güvenlik Sertifikaları
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-green-400">SSL/TLS Sertifikası</h3>
                    <p className="text-gray-300 mb-4">
                      Web sitemiz Extended Validation (EV) SSL sertifikası ile korunmaktadır. 
                      Bu sertifika, verilerinizin şifrelenerek güvenli bir şekilde iletilmesini sağlar.
                    </p>
                    <ul className="text-gray-400 space-y-1">
                      <li>• 256-bit şifreleme teknolojisi</li>
                      <li>• Güncel güvenlik protokolleri</li>
                      <li>• Sürekli güvenlik güncellemeleri</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-blue-400">PCI DSS Uyumluluğu</h3>
                    <p className="text-gray-300 mb-4">
                      Ödeme işlemlerimiz Payment Card Industry Data Security Standard (PCI DSS) 
                      gereksinimlerine tam uyum sağlar.
                    </p>
                    <ul className="text-gray-400 space-y-1">
                      <li>• Kart bilgileri saklanmaz</li>
                      <li>• Güvenli ödeme gateway'i</li>
                      <li>• Düzenli güvenlik denetimleri</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-gray-900 rounded-lg p-8">
                <h2 className="text-2xl font-bold mb-6 flex items-center">
                  <i className="ri-bank-card-line text-blue-500 mr-3"></i>
                  Ödeme Güvenliği
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-blue-400">Kabul Edilen Ödeme Yöntemleri</h3>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3">
                        <i className="ri-bank-card-line text-xl text-gray-400"></i>
                        <span className="text-gray-300">Kredi Kartı (Visa, Mastercard, American Express)</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-bank-line text-xl text-gray-400"></i>
                        <span className="text-gray-300">Banka Kartı (Debit Card)</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-money-dollar-circle-line text-xl text-gray-400"></i>
                        <span className="text-gray-300">Havale/EFT</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-smartphone-line text-xl text-gray-400"></i>
                        <span className="text-gray-300">Mobil Ödeme</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-green-400">3D Secure Doğrulama</h3>
                    <p className="text-gray-300 mb-4">
                      Tüm kredi kartı işlemleri 3D Secure teknolojisi ile korunur. 
                      Bu sistem ek güvenlik katmanı sağlayarak dolandırıcılığı önler.
                    </p>
                    <ul className="text-gray-400 space-y-1">
                      <li>• SMS ile doğrulama</li>
                      <li>• Banka onay sistemi</li>
                      <li>• Gerçek zamanlı fraud kontrolü</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-gray-900 rounded-lg p-8">
                <h2 className="text-2xl font-bold mb-6 flex items-center">
                  <i className="ri-user-settings-line text-purple-500 mr-3"></i>
                  Kişisel Veri Güvenliği
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-purple-400">KVKK Uyumluluğu</h3>
                    <p className="text-gray-300 mb-4">
                      Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında 
                      verilerinizi en üst düzeyde koruyoruz.
                    </p>
                    <ul className="text-gray-400 space-y-1">
                      <li>• Açık rıza ile veri toplama</li>
                      <li>• Veri minimizasyonu ilkesi</li>
                      <li>• Güvenli veri saklama</li>
                      <li>• Veri silme hakkı</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-orange-400">Veri Güvenlik Önlemleri</h3>
                    <p className="text-gray-300 mb-4">
                      Verilerinizin güvenliği için çok katmanlı güvenlik 
                      sistemleri kullanıyoruz.
                    </p>
                    <ul className="text-gray-400 space-y-1">
                      <li>• Şifrelenmiş veri tabanları</li>
                      <li>• Düzenli güvenlik yedekleri</li>
                      <li>• Erişim kontrolü ve izleme</li>
                      <li>• Güvenlik duvarı koruması</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-gray-900 rounded-lg p-8">
                <h2 className="text-2xl font-bold mb-6 flex items-center">
                  <i className="ri-customer-service-line text-yellow-500 mr-3"></i>
                  Müşteri Güvenliği
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-yellow-400">Dolandırıcılık Koruması</h3>
                    <p className="text-gray-300 mb-4">
                      Gelişmiş algoritmaları kullanarak şüpheli işlemleri 
                      otomatik olarak tespit eder ve engelliyoruz.
                    </p>
                    <ul className="text-gray-400 space-y-1">
                      <li>• Gerçek zamanlı işlem analizi</li>
                      <li>• Anormal davranış tespiti</li>
                      <li>• Otomatik risk değerlendirmesi</li>
                      <li>• Hızlı müdahale sistemi</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-red-400">Güvenlik İhlali Protokolü</h3>
                    <p className="text-gray-300 mb-4">
                      Herhangi bir güvenlik sorunu durumunda hızlı ve 
                      etkili müdahale protokolümüz devreye girer.
                    </p>
                    <ul className="text-gray-400 space-y-1">
                      <li>• Anında bildirim sistemi</li>
                      <li>• Acil durum müdahale ekibi</li>
                      <li>• Şeffaf iletişim süreci</li>
                      <li>• Zarar giderme planı</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Security Tips */}
            <div className="bg-gradient-to-r from-blue-900/50 to-purple-900/50 rounded-lg p-8 mt-12">
              <h2 className="text-2xl font-bold mb-6 text-center">Güvenli Alışveriş İpuçları</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-green-400 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold mb-1">Güçlü Şifre Kullanın</h4>
                      <p className="text-gray-300 text-sm">En az 8 karakter, büyük-küçük harf, rakam ve özel karakter içeren şifreler tercih edin.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-green-400 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold mb-1">Güvenli Ağ Kullanın</h4>
                      <p className="text-gray-300 text-sm">Alışveriş yaparken güvenli ve özel internet bağlantısı kullanın.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-green-400 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold mb-1">URL'yi Kontrol Edin</h4>
                      <p className="text-gray-300 text-sm">Adres çubuğunda "https://" ile başladığından ve kilit simgesinin göründüğünden emin olun.</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-green-400 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold mb-1">Hesap Bilgilerini Koruyun</h4>
                      <p className="text-gray-300 text-sm">Kullanıcı adı ve şifrenizi kimseyle paylaşmayın, düzenli olarak değiştirin.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-green-400 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold mb-1">İşlemleri Takip Edin</h4>
                      <p className="text-gray-300 text-sm">Banka ve kredi kartı hesaplarınızı düzenli olarak kontrol edin.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-green-400 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold mb-1">Şüpheli Durumları Bildirin</h4>
                      <p className="text-gray-300 text-sm">Anormal bir durum fark ettiğinizde hemen müşteri hizmetlerimize ulaşın.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <h2 className="text-2xl font-bold mb-4">İletişim</h2>
              <p className="text-gray-300 mb-4">
                Güvenli alışveriş konusunda sorularınız varsa bizimle iletişime geçin:
              </p>
              <div className="bg-gray-800 p-6 rounded-lg">
                <p className="text-white mb-2"><strong>Nox Sanat</strong></p>
                <p className="text-gray-300 mb-2">
                  Gayrette Mahallesi, Çimen Sokak, Girne Apartmanı<br />
                  Beşiktaş / İstanbul
                </p>
                <p className="text-gray-300 mb-2">Telefon: +90 212 555 0123</p>
                <p className="text-gray-300">E-posta: info@noxsanat.com</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
